/**
 * UA parser wrapper. Uses `ua-parser-js@1.0.x` and exposes the 5-field set used
 * on `/dye` query strings (matching yoto-web's `serializeAnalyticsArgs`):
 *
 *   b   = browser name
 *   bv  = browser version
 *   os  = OS name + version (single string, e.g. "Mac OS 14.4")
 *   dev = device vendor + model (single string), or empty for desktop
 *   p   = device type (mobile / tablet / desktop) — see PLATFORM_DESKTOP
 */

import { UAParser } from 'ua-parser-js';

export interface UaFields {
  b: string;
  bv: string;
  os: string;
  dev: string;
  p: string;
}

const PLATFORM_DESKTOP = 'desktop';

let cached: UaFields | null = null;

export function parseUa(): UaFields {
  if (cached) return cached;

  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const parsed = new UAParser(ua).getResult();

  const browserName = parsed.browser.name ?? '';
  const browserVersion = parsed.browser.version ?? '';
  const osName = parsed.os.name ?? '';
  const osVersion = parsed.os.version ?? '';
  const vendor = parsed.device.vendor ?? '';
  const model = parsed.device.model ?? '';

  cached = {
    b: browserName,
    bv: browserVersion,
    os: [osName, osVersion].filter(Boolean).join(' '),
    dev: [vendor, model].filter(Boolean).join(' '),
    p: parsed.device.type ?? PLATFORM_DESKTOP,
  };
  return cached;
}

/** Test-only: forget the cached parse so a different UA can be supplied. */
export function _resetUaCache(): void {
  cached = null;
}
